var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.type == "number"
    ? _c("el-input", {
        directives: [
          {
            name: "wk-number",
            rawName: "v-wk-number",
            value: _vm.inputLimitType,
            expression: "inputLimitType",
          },
        ],
        attrs: { type: _vm.type, disabled: _vm.disabled, maxlength: 100 },
        on: { input: _vm.valueChange },
        model: {
          value: _vm.dataValue,
          callback: function ($$v) {
            _vm.dataValue = $$v
          },
          expression: "dataValue",
        },
      })
    : _c("el-input", {
        attrs: {
          type: _vm.type,
          disabled: _vm.disabled,
          maxlength: 100,
          placeholder: _vm.placeholder,
        },
        on: { input: _vm.valueChange },
        model: {
          value: _vm.dataValue,
          callback: function ($$v) {
            _vm.dataValue = $$v
          },
          expression: "dataValue",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }